export interface ScheduledNotification {
  Id: number;
  Status: any;
  Title: string;
  Body: string;
  DueDate: string; // ISO 8601 datetime format
  DueTime: string; // HH:mm:ss format
  DeliveredAtUtc: string; // ISO 8601 datetime format
}

export enum ScheduledNotificationStatus {
  Scheduled = 1,
  Sent = 2,
  Failed = 3,
  Cancelled = 4
}

export enum ScheduledNotificationActionType {
  Create = 1,
  Edit = 2,
  Resend = 3,
  Cancel = 4,
  SendNow = 5
}

// Severity types
type SeverityType = 'info' | 'success' | 'danger' | 'warning' | 'secondary';

// Status mapping interface
interface Status {
  id: number,
  title: string;
  severity: SeverityType;
}

// Status mapping for displaying titles and severity using Map
const ScheduledNotificationStatusMap = new Map<ScheduledNotificationStatus, Status>([
  [ScheduledNotificationStatus.Scheduled, { id: ScheduledNotificationStatus.Scheduled, title: 'Scheduled', severity: 'info' }],
  [ScheduledNotificationStatus.Sent, { id: ScheduledNotificationStatus.Sent, title: 'Sent', severity: 'success' }],
  [ScheduledNotificationStatus.Failed, { id: ScheduledNotificationStatus.Failed, title: 'Failed', severity: 'danger' }],
  [ScheduledNotificationStatus.Cancelled, { id: ScheduledNotificationStatus.Cancelled, title: 'Cancelled', severity: 'warning' }]
]);

// Utility function to get status mapping (title + severity)
export function getScheduledNotificationStatus(statusId: number): Status {
  return ScheduledNotificationStatusMap.get(statusId as ScheduledNotificationStatus) || { id: 0, title: 'none', severity: 'secondary' };
}